import React, { useEffect, useState } from "react";
import { TaskRepetitionType } from "ui/Scripts/source/models/enums";
import { ITaskDataRow } from "ui/Scripts/source/models/task/taskDataRow";
import { ITaskEditTypeItem, TaskEditTypeItem } from "ui/Scripts/source/models/task/taskEditTypeItem";
import { Translations } from "ui/Scripts/source/models/translations";
import { ReportExcelReportTable } from "../../../../framework/Report/ReportExcelReport/ReportExcelReportTable";
import { TaskDynamicForm } from "../../../TaskDynamicForm/TaskDynamicForm";
import { TaskDynamicFormContainer } from "../../../TaskDynamicFormContainer";
import { TaskDynamicFormTableContainer } from "./TaskDynamicFormTableContainer";
import { DialogSectionCard } from "source/components/framework/Dialog/DialogSectionCard";
import { Box } from "@mui/material";
import { ITaskDataRowCol } from "ui/Scripts/source/models/task/taskDataRowCol";
import { ITaskTypeCol } from "ui/Scripts/source/models/task/taskTypeCol";
import { FormAccordion } from "source/components/framework/FormAccordion";

/* eslint-disable no-unused-vars */
export const enum TaskTypeDialogPreviewType {
    Web = "1",
    Mobile = "2",
    Print = "3",
    PrintRow = "4"
}
/* eslint-enable no-unused-vars */

interface ITaskTypeDialogPreviewWebProps {
    height?: string;
    title: string;
    previewType: TaskTypeDialogPreviewType;
    taskRepetitionType?: TaskRepetitionType;
    // headerCols: ITaskTypeCol[];
    // formCols: ITaskTypeCol[];
    // lineCols: ITaskTypeCol[];
    taskType: ITaskEditTypeItem;
    headerDataRow: ITaskDataRow;
    formDataRow: ITaskDataRow;
    lineDataRow: ITaskDataRow;
    headerTypeCol?: ITaskTypeCol;
    formTypeCol?: ITaskTypeCol;
    onHeaderItemClick: (id: string) => void;
    onFormItemClick: (id: string) => void;
    onUpdateHeaderDataRowCols: (taskDataRowCols: ITaskDataRowCol[]) => void;
    onUpdateFormDataRowCols: (taskDataRowCols: ITaskDataRowCol[]) => void;
}

export const TaskTypeDialogPreviewWeb = (
    props: ITaskTypeDialogPreviewWebProps
) => {
    const [total, setTotal] = useState<{ taskType: ITaskEditTypeItem, totalRow: ITaskDataRow }>({ taskType: null, totalRow: null });

    const headerColsExist = !!props.headerDataRow && props.headerDataRow.cols.length > 0;
    const formColsExist = !!props.formDataRow && props.formDataRow.cols.length > 0;

    useEffect(() => {
        let taskType = total.taskType;
        if (taskType === null) {
            taskType = TaskEditTypeItem.getTotalRowTaskEditTypeItem(props.taskType);
        }
        let totalRow = total.totalRow;
        // console.log("props.formDataRow", props.formDataRow);
        if (taskType.lineCols.length > 0) {
            totalRow = TaskEditTypeItem.getTotalRow(props.taskType, taskType, [props.formDataRow]);
        }
        // console.log("taskType", taskType);
        // console.log("totalRow", totalRow);
        setTotal({ taskType, totalRow });
    }, [props.taskType, props.lineDataRow]);
    
    return (
        <DialogSectionCard headerTitle={props.title} contentPadding="16px 0 16px 0!important">
            <Box
                sx={{
                    position: "relative",
                    height: props.height ?? "calc(100vh - 350px)",
                    overflow: "auto",
                    paddingLeft: "0",
                    paddingRight: "0"
                }}
            >
                {headerColsExist && (
                    <FormAccordion
                        defaultExpanded={true}
                        title={Translations.Header}
                    >
                        <TaskDynamicFormContainer>
                            <TaskDynamicForm
                                mobile={props.previewType === TaskTypeDialogPreviewType.Mobile}
                                taskTypeCols={props.taskType.headerCols}
                                taskDataRowCols={props.headerDataRow.cols}
                                preview={true}
                                selectedField={props.headerTypeCol?.field}
                                onRefreshCols={props.onUpdateHeaderDataRowCols}
                                onComponentClick={props.onHeaderItemClick}
                            />
                        </TaskDynamicFormContainer>
                    </FormAccordion>
                )}
                {formColsExist && (
                    <FormAccordion
                        defaultExpanded={true}
                        title={Translations.Contents}
                    >
                        <TaskDynamicFormContainer>
                            <TaskDynamicForm
                                mobile={props.previewType === TaskTypeDialogPreviewType.Mobile}
                                taskTypeCols={props.taskType.formCols}
                                taskDataRowCols={props.formDataRow.cols}
                                preview={true}
                                selectedField={props.formTypeCol?.field}
                                onRefreshCols={props.onUpdateFormDataRowCols}
                                onComponentClick={props.onFormItemClick}
                            />
                        </TaskDynamicFormContainer>
                    </FormAccordion>
                )}
                {props.taskRepetitionType === TaskRepetitionType.Repeated && !!props.lineDataRow && props.lineDataRow.cols.length > 0 && (
                    <FormAccordion
                        defaultExpanded={true}
                        title={Translations.Line}
                    >
                        <TaskDynamicFormTableContainer
                            mobile={props.previewType === TaskTypeDialogPreviewType.Mobile}
                        >
                            <ReportExcelReportTable
                                taskType={props.taskType}
                                dataRows={[props.formDataRow]}
                                totalTaskType={total.taskType}
                                totalRow={total.totalRow}
                                sortingDisabled={true}
                                sortColumn={""}
                                sortOrderIsAsc={true}
                                selectedColumn={props.formTypeCol?.field}
                                onSetSortData={null}
                                onColumnClick={props.onFormItemClick}
                            />
                        </TaskDynamicFormTableContainer>
                    </FormAccordion>
                )}
            </Box>
        </DialogSectionCard>
    );
};
